export default __webpack_public_path__ + "static/ovo-5bfbd1d66b5e980921f7c5b0cc4be957.png";